<template>
  <div>
    <v-card min-height="550">
      <v-dialog
        v-model="deleteWarningDialog"
        transition="dialog-top-transition"
        max-width="500"
      >
        <template>
          <v-card rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                Warning
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                icon
                class="white--text"
                @click="deleteWarningDialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text
              class="black--text pt-5 text-center"
              style="font-size: 20px"
            >
              <span> Are you sure ? </span>
            </v-card-text>
            <v-card-text
              class="black--text text-center"
              style="font-size: 14px"
            >
              Do you really want to delete this record ?
              <p class="mb-0">This process cannot be undone.</p>
            </v-card-text>
            <div class="mx-4">
              <v-divider></v-divider>
            </div>
            <v-card-actions class="px-4 py-5 justify-center">
              <div>
                <v-spacer></v-spacer>
                <v-btn
                  outlined
                  class="mr-2 px-5"
                  right
                  height="44"
                  depressed
                  color="primary"
                  style="font-weight: 600"
                  @click="deleteWarningDialog = false"
                >
                  {{ $t("cancel") }}
                </v-btn>
                <v-btn
                  @click="deleteRecord"
                  right
                  height="44"
                  color="error"
                  class="px-5"
                  style="font-weight: 600"
                >
                  Delete
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
      <v-dialog v-model="milkFormDialog" max-width="876px">
        <v-form
          ref="milkForm"
          v-model="milkFormValid"
          lazy-validation
          @submit.prevent="submitMilkForm"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" dark class="text-h6">
              <div v-if="isEdit && tableEdit">Edit Current Record</div>
              <div v-else-if="isEdit">Edit Current Record</div>
              <div v-else>Add New Record</div>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeMilkFormDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <div class="px-5 py-5">
              <v-row>
                <v-col cols="12" v-if="isEdit">
                  <v-card flat color="transparent">
                    <v-toolbar
                      class="bdr secondary2light"
                      :elevation="0"
                      outlined
                    >
                      <v-toolbar-title
                        class="grey--text text--darken-2"
                        style="font-size: 13px"
                      >
                        Do you really want to edit this record ? Your previous
                        records might get affected.
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-card>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label"
                    >Daily Milk Yield
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        <span
                          >Amount of milk obtained from an animal in the
                          particular day e.g. Kg/lbs/litres</span
                        ></span
                      >
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    type="number"
                    :min="0"
                    v-model="milkFormData.daily_milk_yield"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label"> {{ "." }}</label>
                  <v-select
                    outlined
                    placeholder="Select Units"
                    dense
                    v-model="milkFormData.daily_milk_yield_unit"
                    :items="milkYieldUnitOptions"
                  ></v-select>
                </v-col>
                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Milk Color
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >Cow milk is light yellow in color due to presence of
                        carotene. Buffalo milk is white in color due to case in
                        (absence of carotene). Cow milk varies from white to
                        creamy white, slightly yellow, depending on the breed
                        and the feed. Cows that are eating fresh green
                        pasturage, or rich green hay or silage, or a fodder,
                        produce milk that is yellowish. White-flakes- mastitis,
                        spoiled milk</span
                      >
                    </v-tooltip></label
                  >
                  <v-select
                    outlined
                    placeholder="Select Color"
                    dense
                    v-model="milkFormData.milk_colour"
                    :items="milkColorOptions"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Milk Taste
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >The taste of the milk(must not be off-flavoured),
                        Normal-Slightly sweety
                      </span>
                    </v-tooltip></label
                  >
                  <v-select
                    outlined
                    placeholder="Select Taste"
                    dense
                    v-model="milkFormData.milk_taste"
                    :items="milkTasteOptions"
                  ></v-select>
                </v-col>
                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Milk Smell
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>The smell must be absent </span>
                    </v-tooltip></label
                  >
                  <v-select
                    outlined
                    placeholder="Select Smell"
                    dense
                    v-model="milkFormData.milk_smell"
                    :items="milkSmellOptions"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <label class="label">
                    {{ $t("animal.performanceInfo.lactationNumber") }}
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          @click="showBodyConditionScoreDialog = true"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span> The ordinal number of lactation</span>
                    </v-tooltip>
                  </label>
                  <v-select
                    :items="locationNumberOptions"
                    outlined
                    dense
                    placeholder="Select Lactating Number"
                    v-model="milkFormData.lactation_number"
                  >
                  </v-select>
                </v-col>

                <v-col cols="6">
                  <label class="label">
                    {{ $t("animal.performanceInfo.lactationLength") }}
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          @click="showBodyConditionScoreDialog = true"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        Is the starting period of milking to the end (dry) of
                        the lactation period
                      </span>
                    </v-tooltip>
                  </label>

                  <v-row>
                    <v-col cols="6">
                      <v-select
                        :items="locationLengthOptions"
                        outlined
                        dense
                        placeholder="e.g. 123"
                        v-model="milkFormData.lactation_length"
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="6">
                      <v-select
                        :items="locationLengthUnitOptions"
                        outlined
                        dense
                        placeholder="Unit"
                        v-model="milkFormData.lactation_length_unit"
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <label class="label">
                    {{ $t("animal.performanceInfo.milkingFrequency") }}
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          @click="showBodyConditionScoreDialog = true"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span> Frequency of milking (e.g. 2 times/ day) </span>
                    </v-tooltip>
                  </label>

                  <v-select
                    :items="milkFrequencyOptions"
                    outlined
                    dense
                    placeholder="Select Milk Frequency"
                    v-model="milkFormData.milking_frequency"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                outlined
                @click="closeMilkFormDialog"
              >
                {{ $t("cancel") }}
              </v-btn>

              <v-btn depressed color="primary" type="submit">
                <span v-if="isEdit">{{ $t("update") }}</span>
                <span v-else>{{ $t("submit") }}</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog v-model="physioFormDialog" max-width="876px">
        <v-form
          ref="physioForm"
          v-model="physioValid"
          lazy-validation
          @submit.prevent="submitPhysioForm"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" dark class="text-h6">
              <div v-if="isEdit && tableEdit">
                Edit Current Record
                <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="red" v-bind="attrs" v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <span>{{
                    ` Do you really want to edit this record ? Your previous records might get affected.`
                  }}</span>
                </v-tooltip>
              </div>
              <div v-else-if="isEdit">Edit Current Record</div>
              <div v-else>Add New Record</div>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closePhysioDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <div class="px-5 py-5">
              <v-row>
                <v-col class="py-0" sm="3">
                  <label class="label"
                    >Acidity of Raw Milk (pH)
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t(
                            "animal.performanceInfo.physioChemical.tooltip.acidityRawMilk"
                          )
                        }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    type="number"
                    v-model="physioFormData.acidity_raw_milk"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label"> {{ "." }}</label>
                  <v-select
                    outlined
                    placeholder="Select Units"
                    dense
                    :items="acidityRawUnitOptions"
                    v-model="physioFormData.acidity_raw_milk_unit"
                  ></v-select>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label"
                    >Specific Gravity (at std. temperature)
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >{{
                          $t(
                            "animal.performanceInfo.physioChemical.tooltip.specificGravity"
                          )
                        }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    type="number"
                    :min="0"
                    v-model="physioFormData.specific_gravity"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label"> {{ "." }}</label>
                  <v-select
                    outlined
                    placeholder="Select Units"
                    dense
                    :items="specificGravityUnitOptions"
                    v-model="physioFormData.specific_gravity_unit"
                  ></v-select>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label"
                    >SNF (Solid Not Fat)/ Protein
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t(
                            "animal.performanceInfo.physioChemical.tooltip.snf"
                          )
                        }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    type="number"
                    :min="0"
                    v-model="physioFormData.solid_not_fat"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label"> {{ "." }}</label>
                  <v-select
                    outlined
                    placeholder="Select Units"
                    dense
                    :items="snfUnitOptions"
                    v-model="physioFormData.solid_not_fat_unit"
                  ></v-select>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label"
                    >Protein Content (kg/dl)
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t(
                            "animal.performanceInfo.physioChemical.tooltip.proteinContent"
                          )
                        }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    type="number"
                    :min="0"
                    v-model="physioFormData.protein_content"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label"> {{ "." }}</label>
                  <v-select
                    outlined
                    placeholder="Select Units"
                    dense
                    :items="proteinContentUnitOptions"
                    v-model="physioFormData.protein_content_unit"
                  ></v-select>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label"
                    >Fat Content (kg/dl)
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >{{
                          $t(
                            "animal.performanceInfo.physioChemical.tooltip.fatContent"
                          )
                        }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    type="number"
                    :min="0"
                    v-model="physioFormData.fat_content"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label"> {{ "." }}</label>
                  <v-select
                    outlined
                    placeholder="Select Units"
                    dense
                    :items="fatContentUnitOptions"
                    v-model="physioFormData.fat_content_unit"
                  ></v-select>
                </v-col>

                <v-col class="py-0" sm="3">
                  <label class="label"
                    >Milk Lactose (%)
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t(
                            "animal.performanceInfo.physioChemical.tooltip.milkLactose"
                          )
                        }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    type="number"
                    :min="0"
                    v-model="physioFormData.milk_lactose"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" sm="3">
                  <label class="label"> {{ "." }}</label>
                  <v-select
                    outlined
                    placeholder="Select Units"
                    dense
                    :items="milkLactoseUnitOptions"
                    v-model="physioFormData.milk_lactose_unit"
                  ></v-select>
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" outlined @click="closePhysioDialog">
                {{ $t("cancel") }}
              </v-btn>
              <v-btn depressed color="primary" type="submit"> Submit </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="microFormDialog" max-width="876px">
        <v-form
          ref="physioForm"
          v-model="microValid"
          lazy-validation
          @submit.prevent="submitMicroForm"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" dark class="text-h6">
              <div v-if="isEdit && tableEdit">
                Edit Current Record
                <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="red" v-bind="attrs" v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <span>{{
                    ` Do you really want to edit this record ? Your previous records might get affected.`
                  }}</span>
                </v-tooltip>
              </div>
              <div v-else-if="isEdit">Edit Current Record</div>
              <div v-else>Add New Record</div>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeMicroDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <div class="px-5 py-5">
              <v-row>
                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Somatic Cell Count
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t(
                            "animal.performanceInfo.microBiological.tooltip.somaticCellCount"
                          )
                        }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-select
                    outlined
                    placeholder="Select Color"
                    dense
                    :items="somaticCellData"
                    v-model="microFormData.somatic_cell_count"
                  ></v-select> </v-col
                ><v-col class="py-0" sm="6">
                  <label class="label"
                    >Preliminary Incubation Counts
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >{{
                          $t(
                            "animal.performanceInfo.microBiological.tooltip.preliminaryIncubation"
                          )
                        }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-select
                    outlined
                    placeholder="Select Color"
                    dense
                    :items="preliminaryIncubationCountData"
                    v-model="microFormData.preliminary_incubation_count"
                  ></v-select> </v-col
                ><v-col class="py-0" sm="6">
                  <label class="label"
                    >The California Mastitis
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t(
                            "animal.performanceInfo.microBiological.tooltip.californiaMastitis"
                          )
                        }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-select
                    outlined
                    placeholder="Select Color"
                    dense
                    :items="milkColorOptions"
                    v-model="microFormData.california_mastitis"
                  ></v-select> </v-col
                ><v-col class="py-0" sm="6">
                  <label class="label"
                    >Total Viable Count
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >{{
                          $t(
                            "animal.performanceInfo.microBiological.tooltip.totalViableCount"
                          )
                        }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-select
                    outlined
                    placeholder="Select Color"
                    dense
                    :items="viableCountData"
                    v-model="microFormData.viable_count"
                  ></v-select> </v-col
                ><v-col class="py-0" sm="6">
                  <label class="label"
                    >Coliform Count
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t(
                            "animal.performanceInfo.microBiological.tooltip.coliformCount"
                          )
                        }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-select
                    outlined
                    placeholder="Select Color"
                    dense
                    :items="coliformCountData"
                    v-model="microFormData.coliform_count"
                  ></v-select> </v-col
                ><v-col class="py-0" sm="6">
                  <label class="label"
                    >Yeast and Mould Count
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t(
                            "animal.performanceInfo.microBiological.tooltip.yeastMouldCount"
                          )
                        }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-select
                    outlined
                    placeholder="Select Color"
                    dense
                    :items="yeastMouldCountData"
                    v-model="microFormData.yeast_mould_count"
                  ></v-select> </v-col
                ><v-col class="py-0" sm="6">
                  <label class="label"
                    >Anitimicrobial Residues
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >{{
                          $t(
                            "animal.performanceInfo.microBiological.tooltip.antimicrobialResidues"
                          )
                        }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-select
                    outlined
                    placeholder="Select Color"
                    dense
                    :items="antiMicrobialData"
                    v-model="microFormData.antimicrobial_residues"
                  ></v-select>
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" outlined @click="closePhysioDialog">
                {{ $t("cancel") }}
              </v-btn>
              <v-btn depressed color="primary" type="submit"> Submit </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <div class="d-flex mb-4">
        <h2>Milk</h2>
        <v-spacer></v-spacer>
        <div>
          <v-btn
            height="50"
            width="300"
            color="primary"
            outlined
            v-show="!disableCurrentRecordButton"
            @click="startEdit(null)"
            >EDIT CURRENT RECORD</v-btn
          >
        </div>
        <div class="ml-5">
          <div class="d-flex justify-end">
            <v-btn
              height="50"
              width="200"
              @click="startCreate"
              dense
              depressed
              color="primary"
              :disabled="panel == undefined"
              >ADD NEW RECORD</v-btn
            >
          </div>
        </div>
      </div>

      <v-row justify="center">
        <v-expansion-panels
          class="mt-5"
          style="max-width: 97.5%"
          flat
          v-model="panel"
        >
          <v-expansion-panel>
            <v-expansion-panel-header class="subtitle-1">
              <span>{{ $t("animal.performanceInfo.milkRecord") }}</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row width="100%">
                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Daily Milk Yield
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span
                                >Amount of milk obtained from an animal in the
                                particular day e.g. Kg/lbs/litres</span
                              >
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentMilkRecord &&
                              currentMilkRecord.dailyMilkYield
                                ? currentMilkRecord.dailyMilkYield
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-icon class="float-right">mdi-dots-horizontal</v-icon>
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Milk Color
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span
                                >Cow milk varies from white to creamy white,
                                slightly yellow, depending on the breed and the
                                feed. Cows that are eating fresh green
                                pasturage, or rich green hay or silage, or a
                                fodder, produce milk that is yellowish. Cow milk
                                is light yellow in color due to presence of
                                carotene. Buffalo milk is white in color due to
                                case in (absence of carotene). White-flakes-
                                mastitis, spoiled milk</span
                              >
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentMilkRecord && currentMilkRecord.milkColour
                                ? currentMilkRecord.milkColour
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-icon class="float-right">mdi-dots-horizontal</v-icon>
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Milk Taste
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span
                                >The taste of the milk(must not be
                                off-flavoured), Normal-Slightly sweety</span
                              >
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentMilkRecord && currentMilkRecord.milkTaste
                                ? currentMilkRecord.milkTaste
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-icon class="float-right">mdi-dots-horizontal</v-icon>
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Milk Smell
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>The smell must be absent</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentMilkRecord && currentMilkRecord.milkSmell
                                ? currentMilkRecord.milkSmell
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-icon class="float-right">mdi-dots-horizontal</v-icon>
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Lactation Number
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span
                                >The ordinal number of times when mother
                                secretes milk from her mammary glands.</span
                              >
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentMilkRecord &&
                              currentMilkRecord.lactationNumber
                                ? currentMilkRecord.lactationNumber
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-icon class="float-right">mdi-dots-horizontal</v-icon>
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Lactation Length
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>
                                Is the starting period of milking to the end
                                (dry) of the lactation period</span
                              >
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentMilkRecord &&
                              currentMilkRecord.lactationLength
                                ? currentMilkRecord.lactationLength +
                                  " " +
                                  currentMilkRecord.lactationLengthUnit
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-icon class="float-right">mdi-dots-horizontal</v-icon>
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Milking Frequency
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span
                                >The number of times a cow is milked in a day
                                (removing milk from the mammary glands) . E.g. 2
                                times/ day</span
                              >
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentMilkRecord &&
                              currentMilkRecord.milkingFrequency
                                ? currentMilkRecord.milkingFrequency
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
              <div>
                <label class="mt-5"> Milk Record History</label>
                <v-data-table
                  class="mt-5 rounded-xl"
                  :headers="milkHeaders"
                  :items="milkRecordData"
                  :items-per-page="20"
                  hide-default-footer
                  :loading="loading"
                  loading-text="Loading Data..."
                >
                  <template v-slot:item.createdAt="{ item }">
                    <div>
                      {{ item.createdAt | formatDate }}
                    </div>
                  </template>
                  <template v-slot:item.lactationLength="{ item }">
                    <div>
                      {{
                        item.lactationLength + " " + item.lactationLengthUnit
                      }}
                    </div>
                  </template>
                  <template v-slot:item.action="{ item }">
                    <div>
                      <v-row>
                        <v-col sm="6">
                          <v-icon
                            dark
                            color="gray"
                            @click="
                              startEdit(item);
                              tableEdit = true;
                            "
                          >
                            mdi-pencil
                          </v-icon>
                        </v-col>
                        <v-col sm="6">
                          <v-icon dark color="red" @click="startDelete(item)">
                            mdi-delete
                          </v-icon>
                        </v-col>
                      </v-row>
                    </div>
                  </template>
                  <template v-slot:footer></template>
                </v-data-table>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="subtitle-1">
              <span>Physiochemical Characteristics</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row width="100%">
                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <div class="d-flex" style="justify-content: flex-end">
                            <v-icon
                              @click="
                                openPhysioDialog(
                                  'acidity-raw-milk',
                                  currentPhysioRecord.acidity_raw_milk,
                                  acidityResult(
                                    currentPhysioRecord.acidity_raw_milk
                                  )
                                )
                              "
                            />
                          </div>

                          <v-list-item-subtitle
                            >Acidity of Raw Milk (pH)
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.performanceInfo.physioChemical.tooltip.acidityRawMilk"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentPhysioRecord &&
                              currentPhysioRecord.acidity_raw_milk
                                ? currentPhysioRecord.acidity_raw_milk +
                                  " " +
                                  currentPhysioRecord.acidity_raw_milk_unit
                                : "Not Specified"
                            }}
                          </v-list-item-title>

                          <div
                            class="d-flex card-border-content"
                            style="justify-content: flex-end"
                          >
                            <span
                              class="card-border-content-pointer"
                              @click="
                                openPhysioDialog(
                                  'acidity-raw-milk',
                                  currentPhysioRecord.acidity_raw_milk,
                                  acidityResult(
                                    currentPhysioRecord.acidity_raw_milk
                                  )
                                )
                              "
                            >
                              {{
                                currentPhysioRecord &&
                                currentPhysioRecord.acidity_raw_milk
                                  ? acidityResult(
                                      currentPhysioRecord.acidity_raw_milk
                                    )
                                  : "N/A"
                              }}
                            </span>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <div class="d-flex" style="justify-content: flex-end">
                            <v-icon
                              @click="
                                openPhysioDialog(
                                  'specific-gravity',
                                  currentPhysioRecord.specific_gravity,
                                  specificGravityResult(
                                    currentPhysioRecord.specific_gravity
                                  )
                                )
                              "
                            />
                          </div>

                          <v-list-item-subtitle
                            >Specific Gravity (at std. Temperature)
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.performanceInfo.physioChemical.tooltip.specificGravity"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentPhysioRecord &&
                              currentPhysioRecord.specific_gravity
                                ? currentPhysioRecord.specific_gravity +
                                  " " +
                                  currentPhysioRecord.specific_gravity_unit
                                : "Not Specified"
                            }}
                          </v-list-item-title>

                          <div
                            class="d-flex card-border-content"
                            style="justify-content: flex-end"
                          >
                            <span
                              class="card-border-content-pointer"
                              @click="
                                openPhysioDialog(
                                  'specific-gravity',
                                  currentPhysioRecord.specific_gravity,
                                  specificGravityResult(
                                    currentPhysioRecord.specific_gravity
                                  )
                                )
                              "
                            >
                              {{
                                currentPhysioRecord &&
                                currentPhysioRecord.specific_gravity
                                  ? specificGravityResult(
                                      currentPhysioRecord.specific_gravity
                                    )
                                  : "N/A"
                              }}
                            </span>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card
                    class="pa-2 green2 elevation-0"
                    style="min-height: 138.98px"
                  >
                    <v-icon class="float-right">mdi-dots-horizontal</v-icon>
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >SNF (Solid Not Fat) / Protein %
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.performanceInfo.physioChemical.tooltip.snf"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentPhysioRecord &&
                              currentPhysioRecord.solid_not_fat
                                ? currentPhysioRecord.solid_not_fat +
                                  " " +
                                  currentPhysioRecord.solid_not_fat_unit
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card
                    class="pa-2 green2 elevation-0"
                    style="min-height: 138.98px"
                  >
                    <v-icon class="float-right">mdi-dots-horizontal</v-icon>
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Protein Content (Kg/dL)
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.performanceInfo.physioChemical.tooltip.proteinContent"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentPhysioRecord &&
                              currentPhysioRecord.protein_content
                                ? currentPhysioRecord.protein_content +
                                  " " +
                                  currentPhysioRecord.protein_content_unit
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card
                    class="pa-2 green2 elevation-0"
                    style="min-height: 138.98px"
                  >
                    <v-icon class="float-right">mdi-dots-horizontal</v-icon>
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Fat Content %
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.performanceInfo.physioChemical.tooltip.fatContent"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentPhysioRecord &&
                              currentPhysioRecord.fat_content
                                ? currentPhysioRecord.fat_content +
                                  " " +
                                  currentPhysioRecord.fat_content_unit
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card
                    class="pa-2 green2 elevation-0"
                    style="min-height: 138.98px"
                  >
                    <v-icon class="float-right">mdi-dots-horizontal</v-icon>
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Milk Lactose (%)
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.performanceInfo.physioChemical.tooltip.milkLactose"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentPhysioRecord &&
                              currentPhysioRecord.milk_lactose
                                ? currentPhysioRecord.milk_lactose +
                                  " " +
                                  currentPhysioRecord.milk_lactose_unit
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
              <div>
                <label class="mt-5"
                  >Physiochemical Characteristics History</label
                >
                <v-data-table
                  class="mt-5 rounded-xl"
                  :headers="physioHeaders"
                  :items="physioRecordData"
                  :items-per-page="20"
                  hide-default-footer
                  :loading="loading"
                  loading-text="Loading Data..."
                >
                  <template v-slot:item.createdAt="{ item }">
                    <div>
                      {{ item.createdAt | formatDate }}
                    </div>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <div>
                      <v-row>
                        <v-col sm="6">
                          <v-icon
                            dark
                            color="gray"
                            @click="
                              startEdit(item);
                              tableEdit = true;
                            "
                          >
                            mdi-pencil
                          </v-icon>
                        </v-col>
                        <v-col sm="6">
                          <v-icon dark color="red" @click="startDelete(item)">
                            mdi-delete
                          </v-icon>
                        </v-col>
                      </v-row>
                    </div>
                  </template>
                  <template v-slot:footer></template>
                </v-data-table>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header class="subtitle-1">
              <span>Microbiological Characteristics</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row width="100%">
                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <div class="d-flex" style="justify-content: flex-end">
                            <v-icon @click="openMicroDialog('somatic-cell')"
                              >mdi-dots-horizontal</v-icon
                            >
                          </div>

                          <v-list-item-subtitle
                            >Somatic Cell Count
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.performanceInfo.microBiological.tooltip.somaticCellCount"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentMicroRecord &&
                              currentMicroRecord.somatic_cell_count
                                ? currentMicroRecord.somatic_cell_count
                                : "Not Specified"
                            }}
                          </v-list-item-title>

                          <div
                            class="d-flex card-border-content"
                            style="justify-content: flex-end"
                          >
                            <span
                              @click="openMicroDialog('somatic-cell')"
                              class="card-border-content-pointer"
                            >
                              {{
                                currentMicroRecord &&
                                currentMicroRecord.somatic_cell_count
                                  ? somaticCellResultData[
                                      currentMicroRecord.somatic_cell_count
                                    ]
                                  : "N/A"
                              }}
                            </span>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <div class="d-flex" style="justify-content: flex-end">
                            <v-icon
                              @click="openMicroDialog('preliminary-incubation')"
                              >mdi-dots-horizontal</v-icon
                            >
                          </div>

                          <v-list-item-subtitle
                            >Preliminary Incubation Counts
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.performanceInfo.microBiological.tooltip.preliminaryIncubation"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentMicroRecord &&
                              currentMicroRecord.preliminary_incubation_count
                                ? currentMicroRecord.preliminary_incubation_count
                                : "Not Specified"
                            }}
                          </v-list-item-title>

                          <div
                            class="d-flex card-border-content"
                            style="justify-content: flex-end"
                          >
                            <span
                              @click="openMicroDialog('preliminary-incubation')"
                              class="card-border-content-pointer"
                            >
                              {{
                                currentMicroRecord &&
                                currentMicroRecord.preliminary_incubation_count
                                  ? preliminaryIncubationResultData[
                                      currentMicroRecord
                                        .preliminary_incubation_count
                                    ]
                                  : "N/A"
                              }}
                            </span>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card
                    class="pa-2 green2 elevation-0"
                    style="min-height: 138.98px"
                  >
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <div class="d-flex" style="justify-content: flex-end">
                            <v-icon>mdi-dots-horizontal</v-icon>
                          </div>

                          <v-list-item-subtitle
                            >The California Mastitis
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.performanceInfo.microBiological.tooltip.californiaMastitis"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentMicroRecord &&
                              currentMicroRecord.california_mastitis
                                ? currentMicroRecord.california_mastitis
                                : "Not Specified"
                            }}
                          </v-list-item-title>

                          <div
                            class="d-flex"
                            style="justify-content: flex-end"
                          ></div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card
                    class="pa-2 green2 elevation-0"
                    style="min-height: 138.98px"
                  >
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <div class="d-flex" style="justify-content: flex-end">
                            <v-icon @click="openMicroDialog('viable-count')"
                              >mdi-dots-horizontal</v-icon
                            >
                          </div>

                          <v-list-item-subtitle
                            >Total Viable Count
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.performanceInfo.microBiological.tooltip.totalViableCount"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentMicroRecord &&
                              currentMicroRecord.viable_count
                                ? currentMicroRecord.viable_count
                                : "Not Specified"
                            }}
                          </v-list-item-title>

                          <div
                            class="d-flex card-border-content"
                            style="justify-content: flex-end"
                          >
                            <span
                              @click="openMicroDialog('viable-count')"
                              class="card-border-content-pointer"
                            >
                              {{
                                currentMicroRecord &&
                                currentMicroRecord.viable_count
                                  ? viableCountResultData[
                                      currentMicroRecord.viable_count
                                    ]
                                  : "N/A"
                              }}
                            </span>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card
                    class="pa-2 green2 elevation-0"
                    style="min-height: 138.98px"
                  >
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <div class="d-flex" style="justify-content: flex-end">
                            <v-icon @click="openMicroDialog('coliform-count')"
                              >mdi-dots-horizontal</v-icon
                            >
                          </div>

                          <v-list-item-subtitle
                            >Caliform Count
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.performanceInfo.microBiological.tooltip.coliformCount"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentMicroRecord &&
                              currentMicroRecord.coliform_count
                                ? currentMicroRecord.coliform_count
                                : "Not Specified"
                            }}
                          </v-list-item-title>

                          <div
                            class="d-flex card-border-content"
                            style="justify-content: flex-end"
                          >
                            <span
                              @click="openMicroDialog('coliform-count')"
                              class="card-border-content-pointer"
                            >
                              {{
                                currentMicroRecord &&
                                currentMicroRecord.coliform_count
                                  ? coliformCountResultData[
                                      currentMicroRecord.coliform_count
                                    ]
                                  : "N/A"
                              }}
                            </span>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card
                    class="pa-2 green2 elevation-0"
                    style="min-height: 138.98px"
                  >
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <div class="d-flex" style="justify-content: flex-end">
                            <v-icon
                              @click="openMicroDialog('yeast-mould-count')"
                              >mdi-dots-horizontal</v-icon
                            >
                          </div>

                          <v-list-item-subtitle
                            >Yeast and Mould Count
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.performanceInfo.microBiological.tooltip.yeastMouldCount"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentMicroRecord &&
                              currentMicroRecord.yeast_mould_count
                                ? currentMicroRecord.yeast_mould_count
                                : "Not Specified"
                            }}
                          </v-list-item-title>

                          <div
                            class="d-flex card-border-content"
                            style="justify-content: flex-end"
                          >
                            <span
                              @click="openMicroDialog('yeast-mould-count')"
                              class="card-border-content-pointer"
                            >
                              {{
                                currentMicroRecord &&
                                currentMicroRecord.yeast_mould_count
                                  ? yeastMouldResultData[
                                      currentMicroRecord.yeast_mould_count
                                    ]
                                  : "N/A"
                              }}
                            </span>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card
                    class="pa-2 green2 elevation-0"
                    style="min-height: 138.98px"
                  >
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <div class="d-flex" style="justify-content: flex-end">
                            <v-icon>mdi-dots-horizontal</v-icon>
                          </div>

                          <v-list-item-subtitle
                            >Antimicrobial Residues
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.performanceInfo.microBiological.tooltip.antimicrobialResidues"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentMicroRecord &&
                              currentMicroRecord.antimicrobial_residues
                                ? currentMicroRecord.antimicrobial_residues
                                : "Not Specified"
                            }}
                          </v-list-item-title>

                          <div
                            class="d-flex"
                            style="justify-content: flex-end"
                          ></div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
              <div>
                <label class="mt-5">
                  Microbiological Characteristics History</label
                >
                <v-data-table
                  class="mt-5 rounded-xl"
                  :headers="microHeaders"
                  :items="microRecordData"
                  :items-per-page="20"
                  hide-default-footer
                  :loading="loading"
                  loading-text="Loading Data..."
                >
                  <template v-slot:item.createdAt="{ item }">
                    <div>
                      {{ item.createdAt | formatDate }}
                    </div>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <div>
                      <v-row>
                        <v-col sm="6">
                          <v-icon
                            dark
                            color="gray"
                            @click="
                              startEdit(item);
                              tableEdit = true;
                            "
                          >
                            mdi-pencil
                          </v-icon>
                        </v-col>
                        <v-col sm="6">
                          <v-icon dark color="red" @click="startDelete(item)">
                            mdi-delete
                          </v-icon>
                        </v-col>
                      </v-row>
                    </div>
                  </template>
                  <template v-slot:footer></template>
                </v-data-table>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </v-card>
    <micro-biological-dialog
      v-if="isMicroDialog"
      :dialogI="isMicroDialog"
      :dialogCode="microDialogCode"
      @closeDialog="isMicroDialog = false"
    />
    <physio-chemical-dialog
      v-if="isPhysioDialog"
      :dialogI="isPhysioDialog"
      :acidityRawMilkOrGravityValue="acidityRawMilkOrGravityValue"
      :acidityRawMilkOrGravityResult="acidityRawMilkOrGravityResult"
      :dialogCode="physioDialogCode"
      @closeDialog="isPhysioDialog = false"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import loading from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";
import {
  createAnimalMilkRecord,
  updateAnimalMilkRecord,
  animalMilkRecordHistories,
  getPhysioChemicalRecordByAnimalId,
  getMicroBiologicalRecordByAnimalId,
  createPhysioChemicalRecord,
  createMicroBiologicalRecord,
  updatePhysioChemicalRecord,
  updateMicroBiologicalRecord,
  deletePhysioChemicalRecordById,
  deleteMicroBiologicalRecordById,
  deleteAnimalMilkRecord,
} from "@/graphql/Performance.gql";
import MicroBiologicalDialog from "@/views/animals/performance/Dialog/MicroBiologicalDialog";
import PhysioChemicalDialog from "@/views/animals/performance/Dialog/PhysioChemicalDialog";

export default {
  apollo: {
    milkReports: {
      query: animalMilkRecordHistories,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
        };
      },
      result: function ({ data }) {
        if (data) {
          this.currentMilkRecord = data.animalMilkRecordHistories[0] || null;
          this.milkRecordData = data.animalMilkRecordHistories;
        }
      },
      update: (data) => {
        console.log(data);
      },
      error: (err) =>
        this.$notify({
          title: "Error loading data!",
          text: err,
          type: "error",
          position: "top right",
        }),
    },

    getPhysioChemicalRecordByAnimalId: {
      query: getPhysioChemicalRecordByAnimalId,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
        };
      },
      result: function ({ data }) {
        if (data) {
          this.currentPhysioRecord =
            data.getPhysioChemicalRecordByAnimalId[0] || null;
          this.physioRecordData = data.getPhysioChemicalRecordByAnimalId;
        }
      },
      update: (data) => {
        console.log(data);
      },
      error: (err) =>
        this.$notify({
          title: "Error loading data!",
          text: err,
          type: "error",
          position: "top right",
        }),
    },

    getMicroBiologicalRecordByAnimalId: {
      query: getMicroBiologicalRecordByAnimalId,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
        };
      },
      result: function ({ data }) {
        if (data) {
          this.currentMicroRecord =
            data.getMicroBiologicalRecordByAnimalId[0] || null;
          this.microRecordData = data.getMicroBiologicalRecordByAnimalId;
        }
      },
      update: (data) => {
        console.log(data);
      },
      error: (err) =>
        this.$notify({
          title: "Error loading data!",
          text: err,
          type: "error",
          position: "top right",
        }),
    },
  },
  created() {
    console.log("treatment");
  },
  mixins: [generalMixin, loading],
  data() {
    return {
      acidityRawMilkOrGravityValue: null,
      isMicroDialog: false,
      isPhysioDialog: false,
      loading: false,
      tableEdit: false,
      currentEditItem: null,
      editDialog: false,
      physioValid: false,
      microValid: false,
      prognosisStartMenu: false,
      prognosisEndMenu: false,
      physioFormDialog: false,
      microFormDialog: false,
      nowDate: new Date().toISOString().slice(0, 10),
      deleteWarningDialog: false,
      currentMilkRecord: null,
      currentPhysioRecord: null,
      currentMicroRecord: null,
      milkHeaders: [
        {
          text: "Date",
          align: "start",
          sortable: true,
          value: "createdAt",
        },
        {
          text: "Daily Milk Yield",
          align: "start",
          sortable: true,
          value: "dailyMilkYield",
        },
        {
          text: "Milk Color",
          align: "start",
          sortable: true,
          value: "milkColour",
        },
        {
          text: "Milk Taste",
          align: "start",
          sortable: true,
          value: "milkTaste",
        },
        {
          text: "Milk Smell",
          align: "start",
          sortable: true,
          value: "milkSmell",
        },
        {
          text: "Lactation Number",
          align: "start",
          sortable: true,
          value: "lactationNumber",
        },
        {
          text: "Lactation Length",
          align: "start",
          sortable: true,
          value: "lactationLength",
        },
        {
          text: "Milk Frequency",
          align: "start",
          sortable: true,
          value: "milkingFrequency",
        },
        {
          text: "",
          align: "start",
          sortable: true,
          value: "action",
        },
      ],
      physioHeaders: [
        {
          text: "Date",
          align: "start",
          sortable: true,
          value: "createdAt",
        },
        {
          text: "Acidity of Raw Milk (ph)",
          align: "start",
          sortable: true,
          value: "acidity_raw_milk",
        },
        {
          text: "Specific Gravity (at std. Temperature)",
          align: "start",
          sortable: true,
          value: "specific_gravity",
        },
        {
          text: "SNF (Solid Not Fat) / Protein %",
          align: "start",
          sortable: true,
          value: "solid_not_fat",
        },
        {
          text: "Protein Content (Kg/dl)",
          align: "start",
          sortable: true,
          value: "protein_content",
        },
        {
          text: "",
          align: "start",
          sortable: true,
          value: "action",
        },
      ],
      microHeaders: [
        {
          text: "Date",
          align: "start",
          sortable: true,
          value: "createdAt",
        },
        {
          text: "Somatic Cell Count",
          align: "start",
          sortable: true,
          value: "somatic_cell_count",
        },
        {
          text: "Preliminary Incubation Counts",
          align: "start",
          sortable: true,
          value: "preliminary_incubation_count",
        },
        {
          text: "The California Mastitis",
          align: "start",
          sortable: true,
          value: "california_mastitis",
        },
        {
          text: "Total Viable Count",
          align: "start",
          sortable: true,
          value: "viable_count",
        },
        {
          text: "Caliform Count",
          align: "start",
          sortable: true,
          value: "coliform_count",
        },
        {
          text: "",
          align: "start",
          sortable: true,
          value: "action",
        },
      ],
      findAllTreatment: [],
      treatmentDateMenu: false,
      milkFormValid: false,
      withdrawPeriodUnitsOptions: [
        { text: "Hour(s)", value: "1" },
        { text: "Day(s)", value: "2" },
        { text: "Week(s)", value: "3" },
      ],
      milkFormData: {},
      physioFormData: {},
      microFormData: {},
      milkFormDialog: false,
      panel: 0,
      isEdit: false,
      treatmentRules: {
        drugWithdrawalperiod: [
          (v) => {
            if (v) return v >= 0 || "Value cannot be less than 0";
          },
        ],
      },

      milkRecordData: [],
      physioRecordData: [],
      microRecordData: [],
      microDialogCode: null,
      physioDialogCode: null,
      acidityRawMilkOrGravityResult: null,
    };
  },
  methods: {
    acidityResult(data) {
      if (5.1 <= data && data <= 6.7) {
        return "Low";
      } else if (6.8 <= data && data <= 7) {
        return "Normal";
      } else if (data > 7.1) {
        return "High";
      } else {
        return "N/A";
      }
    },
    specificGravityResult(data) {
      if (1 <= data && data <= 1.02) {
        return "Low";
      } else if (1.021 <= data && data <= 1.03) {
        return "Normal";
      } else if (data > 1.031) {
        return "High";
      } else {
        return "N/A";
      }
    },
    getEditRecord() {
      if (this.panel == 0) {
        return this.currentMilkRecord || this.milkRecordData[0];
      } else if (this.panel == 1) {
        return this.currentPhysioRecord || this.physioRecordData[0];
      } else if (this.panel == 2) {
        return this.currentMicroRecord || this.microRecordData[0];
      }
    },
    openMicroDialog(dialogCode) {
      this.isMicroDialog = true;
      this.microDialogCode = dialogCode;
    },
    openPhysioDialog(
      dialogCode,
      acidityRawMilkOrGravityValue,
      acidityRawMilkOrGravityResult
    ) {
      this.isPhysioDialog = true;
      this.physioDialogCode = dialogCode;
      this.acidityRawMilkOrGravityValue = acidityRawMilkOrGravityValue;
      this.acidityRawMilkOrGravityResult = acidityRawMilkOrGravityResult;
    },
    closeEditConfirmation() {
      this.editDialog = false;
    },

    async deleteRecord() {
      if (this.panel == 0) {
        this.startLoading();
        try {
          await this.$apollo.mutate({
            mutation: deleteAnimalMilkRecord,
            variables: {
              id: Number(this.milkFormData.id),
            },
          });
          this.$notify({
            title: `Record deleted successfully`,
            type: "success",
            position: "top right",
          });
          this.deleteWarningDialog = false;
          this.$apollo.queries.milkReports.refetch();
          this.currentMicroRecord = await this.milkReports[0];
        } catch (error) {
          this.stopLoading();
        }
        this.stopLoading();
      } else if (this.panel == 1) {
        this.startLoading();
        try {
          await this.$apollo.mutate({
            mutation: deletePhysioChemicalRecordById,
            variables: {
              id: Number(this.physioFormData.id),
            },
          });
          this.$apollo.queries.getPhysioChemicalRecordByAnimalId.refetch();
          this.deleteWarningDialog = false;
          this.currentPhysioRecord = await this
            .getPhysioChemicalRecordByAnimalId[0];
          this.$notify({
            title: `Record Deleted Successfully`,
            type: "success",
            position: "top right",
          });
        } catch (error) {
          this.stopLoading();
        }
        this.stopLoading();
      } else if (this.panel == 2) {
        this.startLoading();
        try {
          await this.$apollo.mutate({
            mutation: deleteMicroBiologicalRecordById,
            variables: {
              id: Number(this.microFormData.id),
            },
          });
          this.$apollo.queries.getMicroBiologicalRecordByAnimalId.refetch();
          this.deleteWarningDialog = false;
          this.currentMicroRecord = await this
            .getMicroBiologicalRecordByAnimalId[0];
          this.$notify({
            title: `Record Deleted Successfully`,
            type: "success",
            position: "top right",
          });
        } catch (error) {
          this.stopLoading();
        }
        this.stopLoading();
      }
    },
    startEdit(item) {
      this.editDialog = false;
      if (this.panel == 0) {
        this.isEdit = true;
        this.currentMilkRecord = item || this.milkRecordData[0];
        this.milkEditData = item || this.milkRecordData[0];
        this.milkFormData = {
          id: this.milkEditData.id,
          animalId: this.milkEditData.animalId,
          daily_milk_yield: parseFloat(this.milkEditData.dailyMilkYield),
          daily_milk_yield_unit: this.milkEditData.dailyMilkYeildUnit,
          lactation_length: parseInt(this.milkEditData.lactationLength),
          lactation_length_unit: this.milkEditData.lactationLengthUnit,
          lactation_number: parseInt(this.milkEditData.lactationNumber),
          milk_colour: this.milkEditData.milkColour,
          milking_frequency: parseInt(this.milkEditData.milkingFrequency),
          milk_taste: this.milkEditData.milkTaste,
          milk_smell: this.milkEditData.milkSmell,
        };
        this.milkFormDialog = true;
      } else if (this.panel == 1) {
        this.isEdit = true;
        this.currentPhysioRecord = item || this.physioRecordData[0];
        this.physioFormData = item || this.physioRecordData[0];
        this.physioFormDialog = true;
      } else {
        this.isEdit = true;
        this.currentMicroRecord = item || this.microRecordData[0];
        this.microFormData = item || this.microRecordData[0];
        this.microFormDialog = true;
      }
    },

    startDelete(item) {
      if (this.panel == 0) {
        this.milkFormData = item;
        this.deleteWarningDialog = true;
      } else if (this.panel == 1) {
        this.physioFormData = item;
        this.deleteWarningDialog = true;
      } else {
        this.microFormData = item;
        this.deleteWarningDialog = true;
      }
    },
    startCreate() {
      if (this.panel == 0) {
        this.isEdit = false;
        this.milkFormData = {};
        this.milkFormDialog = true;
      } else if (this.panel == 1) {
        this.isEdit = false;
        this.physioFormData = {};
        this.physioFormDialog = true;
      } else if (this.panel == 2) {
        this.isEdit = false;
        this.microFormData = {};
        this.microFormDialog = true;
      }
    },
    closeMilkFormDialog() {
      this.milkFormDialog = false;
      this.milkFormData = false;
    },
    closePhysioDialog() {
      this.physioFormDialog = false;
      this.physioFormData = {};
    },
    closeMicroDialog() {
      this.microFormDialog = false;
      this.microFormData = {};
    },
    async submitMilkForm() {
      if (Object.keys(this.milkFormData).length == 0) {
        this.$notify({
          text: "No details entered.",
          type: "error",
          position: "top right",
        });
        return;
      }

      this.milkFormData.animalId = Number(this.$route.params.animal_number);
      this.milkFormData.daily_milk_yield = Number(
        this.milkFormData.daily_milk_yield
      );
      this.startLoading();
      if (this.isEdit) {
        this.milkFormData.id = Number(this.milkFormData.id);
        try {
          await this.$apollo.mutate({
            mutation: updateAnimalMilkRecord,
            variables: {
              data: this.milkFormData,
            },
          });
          this.$notify({
            title: `Data updated successfully`,
            type: "success",
            position: "top right",
          });

          this.milkFormDialog = false;
          this.$apollo.queries.milkReports.refetch();
          this.currentMilkRecord = this.milkReports[0];
        } catch (e) {
          this.stopLoading();
          this.closeMilkFormDialog();
          // this.$notify({
          //   title: `Problem with data.`,
          //   text: e.message,
          //   type: "error",
          //   position: "top right",
          // });
        }
      } else {
        try {
          await this.$apollo.mutate({
            mutation: createAnimalMilkRecord,
            variables: {
              data: this.milkFormData,
            },
          });
          this.$notify({
            title: `Data added successfully`,
            type: "success",
            position: "top right",
          });
          this.milkFormDialog = false;
          this.$apollo.queries.milkReports.refetch();
          this.currentMilkRecord = this.milkReports[0];
        } catch (e) {
          this.stopLoading();
          this.closeMilkFormDialog();
          // this.$notify({
          //   title: `Problem with data.`,
          //   text: e.message,
          //   type: "error",
          //   position: "top right",
          // });
        }
      }

      this.stopLoading();
    },
    async submitPhysioForm() {
      if (Object.keys(this.physioFormData).length == 0) {
        this.$notify({
          text: "No details entered.",
          type: "error",
          position: "top right",
        });
        return;
      }

      this.physioFormData.animalId = Number(this.$route.params.animal_number);
      this.physioFormData.acidity_raw_milk = Number(
        this.physioFormData.acidity_raw_milk
      );
      this.physioFormData.specific_gravity = Number(
        this.physioFormData.specific_gravity
      );
      this.physioFormData.solid_not_fat = Number(
        this.physioFormData.solid_not_fat
      );
      this.physioFormData.protein_content = Number(
        this.physioFormData.protein_content
      );
      this.physioFormData.fat_content = Number(this.physioFormData.fat_content);
      this.physioFormData.milk_lactose = Number(
        this.physioFormData.milk_lactose
      );
      this.startLoading();
      if (this.isEdit) {
        try {
          let formData = {
            ...this.physioFormData,
          };
          delete formData.__typename;
          delete formData.createdAt;
          delete formData.updatedAt;
          delete formData.is_deleted;
          delete formData.id;
          await this.$apollo.mutate({
            mutation: updatePhysioChemicalRecord,
            variables: {
              recordId: Number(this.physioFormData.id),
              physioChemicalRecordInput: formData,
            },
          });
          this.closePhysioDialog();

          this.$notify({
            title: `Physio Chemical Record Updated Successfully`,
            type: "success",
            position: "top right",
          });
        } catch (error) {
          this.stopLoading();
          this.closePhysioDialog();
        }
      } else {
        try {
          await this.$apollo.mutate({
            // Query
            mutation: createPhysioChemicalRecord,
            // Parameters
            variables: {
              physioChemicalRecordInput: this.physioFormData,
            },
          });
          this.closePhysioDialog();

          await this.$apollo.queries.getPhysioChemicalRecordByAnimalId.refetch();
          this.$notify({
            title: `Micro Biological Record created  Successfully`,

            type: "success",
            position: "top right",
          });
        } catch (error) {
          this.stopLoading();
          this.closePhysioDialog();
        }
      }

      this.stopLoading();
    },

    async submitMicroForm() {
      if (Object.keys(this.microFormData).length == 0) {
        this.$notify({
          //title: `No details entered.`,
          text: "No details entered.",
          type: "error",
          position: "top right",
        });
        return;
      }

      this.microFormData.animalId = Number(this.$route.params.animal_number);
      this.startLoading();
      if (this.isEdit) {
        let formData = { ...this.microFormData };
        delete formData.__typename;
        delete formData.createdAt;
        delete formData.updatedAt;
        delete formData.is_deleted;
        delete formData.id;
        try {
          await this.$apollo.mutate({
            mutation: updateMicroBiologicalRecord,
            variables: {
              recordId: Number(this.microFormData.id),
              microBiologicalRecordInput: formData,
            },
          });
          this.closeMicroDialog();
          this.$notify({
            title: `Record Updated  Successfully`,

            type: "success",
            position: "top right",
          });
        } catch (error) {
          this.stopLoading();
          this.closeMicroDialog();
        }
      } else {
        try {
          await this.$apollo.mutate({
            mutation: createMicroBiologicalRecord,
            // Parameters
            variables: {
              microBiologicalRecordInput: this.microFormData,
            },
          });
          this.closeMicroDialog();
          await this.$apollo.queries.getMicroBiologicalRecordByAnimalId.refetch();
          this.currentMicroRecord = this.getMicroBiologicalRecordByAnimalId[0];
          this.$notify({
            title: `Micro Biological record Created Successfully`,

            type: "success",
            position: "top right",
          });
        } catch (error) {
          this.stopLoading();
          this.closeMicroDialog();
        }
      }

      this.stopLoading();
    },
  },
  components: {
    "micro-biological-dialog": MicroBiologicalDialog,
    "physio-chemical-dialog": PhysioChemicalDialog,
  },
  computed: {
    ...mapGetters([""]),
    disableCurrentRecordButton() {
      if (this.panel == undefined) {
        return true;
      } else if (this.panel == 0 && !this.currentMilkRecord) {
        return true;
      } else if (this.panel == 1 && !this.currentPhysioRecord) {
        return true;
      } else if (this.panel == 2 && !this.currentMicroRecord) {
        return true;
      } else {
        return false;
      }
    },
    acidityRawUnitOptions() {
      return ["pH"];
    },
    specificGravityUnitOptions() {
      return ["° C"];
    },
    snfUnitOptions() {
      return ["%"];
    },
    proteinContentUnitOptions() {
      return ["kg", "lb(s)", "liter(s)"];
    },
    fatContentUnitOptions() {
      return ["%"];
    },
    milkYieldUnitOptions() {
      return ["kg", "lb(s)", "liter(s)"];
    },
    proteinYieldUnitOptions() {
      return ["kg", "lb(s)"];
    },
    milkLactoseUnitOptions() {
      return ["%"];
    },
    milkUreaUnitOptions() {
      return ["mg", "dl"];
    },
    milkColorOptions() {
      return [
        "Yellow",
        "Cream White",
        "White with Flakes",
        "Yellow with Flakes",
        "Red",
        "Other",
      ];
    },
    milkTasteOptions() {
      return [
        "Slightly Sweet",
        "Sour",
        "Soapy Bitter/Rancid Flavour",
        "Metallic/Cardboardy",
        "Feed Flavor",
        "Fermented",
        "Putrid Malty Flavor",
        "Cowy",
        "Nutty",
        "Salty",
      ];
    },
    milkSmellOptions() {
      return [
        "No Smell",
        "Odor",
        "Rotten",
        "Smell",
        "Fishy off-Flavour",
        "Rancid Odor",
        "Other",
      ];
    },
    locationNumberOptions() {
      return [1, 2, 3, 4, 5];
    },
    locationLengthOptions() {
      return [1, 2, 3, 4, 5];
    },
    locationLengthUnitOptions() {
      return ["days", "weeks", "months", "years"];
    },
    milkFrequencyOptions() {
      return [1, 2, 3, 4, 5];
    },
    somaticCellData() {
      return [
        "100,000 cells/ml",
        "100000-199000",
        "200000-299000",
        "300000-399000",
        ">400000",
      ];
    },

    somaticCellResultData() {
      return {
        "100,000 cells/ml": "Normal",
        "100000-199000": "Required Observation",
        "200000-299000": "Suspected",
        "300000-399000": "Affected",
        ">400000": "Suffering",
      };
    },
    preliminaryIncubationCountData() {
      return ["<100000 cfu/ml", "10,000-50000 cfu/ml", ">50,000 cfu/ml"];
    },
    preliminaryIncubationResultData() {
      return {
        "<100000 cfu/ml": "Ideal",
        "10,000-50000 cfu/ml": "Acceptable",
        ">50,000 cfu/ml": "Concerned",
      };
    },
    viableCountData() {
      return ["<5000", "5000-10000", ">10,000"];
    },
    viableCountResultData() {
      return {
        "<5000": "Recommended",
        "5000-10000": "Medium",
        ">10,000": "High",
      };
    },

    coliformCountData() {
      return ["<50", "50-100", ">10,000"];
    },
    coliformCountResultData() {
      return { "<50": "Recommended", "50-100": "Medium", ">10,000": "High" };
    },
    yeastMouldCountData() {
      return ["<30", "30-50", ">50"];
    },
    yeastMouldResultData() {
      return {
        "<30": "Acceptable",
        "30-50": "Satisfactory Quality",
        ">50": "Affected",
      };
    },
    antiMicrobialData() {
      return ["Negative", "Positive"];
    },
  },
  mounted() {
    this.panel = 0;
  },
  watch: {
    refreshProp() {
      this.panel = 0;
    },
  },
  props: ["treatment", "refreshProp"],
};
</script>

<style lang="scss" scoped>
.v-expansion-panel {
  margin-top: 10px;
}
.v-expansion-panel-header {
  background: #f3f3f380;
  border-radius: 5px;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 0;
}

.card-border-content {
  color: var(--Secondary-1, #00bd73);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.7px;
}
.card-border-content-pointer {
  cursor: pointer;
}
</style>
